module.exports = __webpack_public_path__ + "static/media/instagram.27930208.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instagram.svg
// module id = 276
// module chunks = 0